// removed by extract-text-webpack-plugin
module.exports = {"container":"container-MBHcF","alternateLink":"alternateLink-1Ug6E","button":"button-97MMb","or":"or-2DU3i","hr":"hr-FrSAw","orText":"orText-FTmEP","leftAlign":"leftAlign-1wyXx","errorMessage":"errorMessage-d1Dp5 errorMessage-ucFof"};


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/_auth.css
// module id = 329
// module chunks = 1